export let nodeCountSingularScreenReaderOnlyText = "COV9Bb";
export let nodeCountPluralScreenReaderOnlyText = "lLnreb";
export default {nodeCountSingularScreenReaderOnlyText,nodeCountPluralScreenReaderOnlyText};